import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { inductryMaster } from '../../Models/InductryMasterModel'
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AdminInductryMasterServices {

  apiURL: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.apiURL = sessionStorage.getItem("BaseURL") || '';
      this.apiURL = this.apiURL + 'api/InductryMasterAdmin';
    }
  }

  GetInductryMasterFilterByPage(TokenKey: string, PageNumber: string, PageSize: string, WhereCondition: string, OrderBy: string): Observable<inductryMaster[]> {
    debugger;
    let fullAPIPath = this.apiURL + '/GetInductryMasterFilterByPage/' + PageNumber + '/' + PageSize + '/' + WhereCondition + '/' + OrderBy;
    //console.log(fullAPIPath);
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this.http.get<inductryMaster[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  AddUpdateInductryMaster(TokenKey: string, industryName: string, isActive: string, inductryId: string): Observable<number> {
    debugger;
    let data = "/" + industryName + "/" + isActive + "/" + inductryId;
    let fullAPIPath = this.apiURL + '/AddUpdateInductryMaster' + data;
    console.log(fullAPIPath);
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };

    return this.http.post<number>(fullAPIPath, data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteInductryMaster(TokenKey: string, inductryId: string): Observable<number> {
    debugger;
    let data = "/" + inductryId;
    let fullAPIPath = this.apiURL + '/DeleteInductryMaster' + data;
    console.log(fullAPIPath);
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };

    return this.http.post<number>(fullAPIPath, data, httpOptions)
      .pipe(catchError(this.handleError));
  }
  getIndustry(TokenKey: string, inductryId: string): Observable<inductryMaster> {
    debugger;
    let data = "/" + inductryId;
    let fullAPIPath = this.apiURL + '/GetInductryMaster' + data;
    console.log(fullAPIPath);
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };

    return this.http.get<inductryMaster>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }
  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.status)
  }

}
